module.exports = __webpack_public_path__ + "static/Q2Answer3_santorini_wishmas-41ae705c1c133177a05bac604cda20b3.jpg";